export enum ValuePropositionTypes {
  DEFAULT = 'vpDefault',
  LARGE = 'vpLarge',
  LARGE_WITH_LINKS = 'vpLargeWithLinks',
  DOUBLE = 'vpDouble',
  TRIPPLE = 'vpTripple',
  CHECKLIST = 'vpChecklist',
  TABS = 'vpTabs',
}
